import { FiCountry, getCountryCodeFromCookie } from '../contexts/LocaleContext';
import { getFiGrowthBook, useIsGrowthBookEnabled } from '../lib/growthbook';

/**
 * Whether this visitor is enrolled in the hardware-first checkout, read from the boolean
 * 'hardware-first-checkout-2' feature. false or absent means control. All pricing comes from the server.
 *
 * Evaluated on every render (not memoized) so a flag or attribute change picked up by
 * GrowthBookProvider's re-render is reflected immediately, instead of freezing at the
 * value seen on mount.
 */
export default function useHardwareFirstCheckout(): boolean {
  const isGrowthBookEnabled = useIsGrowthBookEnabled();

  if (!isGrowthBookEnabled) {
    return false;
  }
  // the feature is forced on for US, so a session whose growthbook fetch failed or timed out gets the
  // answer the payload would have given. the default only applies while the feature is absent.
  const growthBook = getFiGrowthBook();
  const fallback = !growthBook.featuresLoaded && getCountryCodeFromCookie() === FiCountry.US;
  return growthBook.getFeatureValue<boolean>('hardware-first-checkout-2', fallback);
}
